import PageNameBanner from "../../components/page-name-banner/PageNameBanner";
import './privacy-policy.css';
import { useEffect } from 'react';


export default function PrivacyPolicy() {

    return (

        <>
            <PageNameBanner pageName="Privacy Policy" />
            <div className="privacy-policy-text">

                <p><strong>Privacy Policy</strong></p>


                <p>Last Updated: 11/25/2024</p>


                <p>
                    At One Life Funding, we are committed to protecting the privacy and security of our clients' personal and financial information. This Privacy Policy outlines the types of data we collect, how we use it, and the measures we take to protect your privacy when you visit our website, onelifefunding.com (the "Site"), or interact with our private equity lending services.

                    Please read this policy carefully so that you understand your rights in relation to your Personal Information, and how your Personal Information and usage information will be collected, used and processed by us. By accessing or using the Site, you agree to the terms outlined in this Privacy Policy. If you do not agree with these terms, please discontinue use of our Site and services.
                </p>


                <p><strong>1. Information We Collect</strong></p>


                <p>
                    We may collect the following types of information when you visit our Site or engage with our services:

                    a. Personal Information

                    <ul>
                        <li> Identification Data: Your name, address, email address, phone number, and identification documents (such as a driver's license or passport).</li>
                        <li> Demographic information: Information including your age, gender, or other similar demographic information when such information is relevant to a particular financial product or service you have requested.</li>
                        <li> Financial Data: Bank account details, credit history, investment history, tax identification numbers, and other financial information required for loan underwriting or investment evaluation.</li>
                        <li> Transaction Data: Details about transactions you have made through our services, including loan amounts, repayments, and investment activities.</li>
                        <li> Consumer reporting agencies and other third-parties: We may also, at your direction, receive credit reports or scores from consumer reporting agencies such as TransUnion,</li>
                    </ul>

                    Experian, or Equifax, or from third-party services that provide a mechanism to share information you have provided to the third-party through the use of an application program interface (API), such as Facebook Connect or the X (formerly known as Twitter) API.
<ul>
    
                        <li> Identify verification partners: We work with third-party partners to help us verify your identity and supplement the Personal Information you provide to ensure the accuracy of the information. For example, the third-party partners may verify your contact information or provide additional details about your address.</li>
                        <li> Public information: We may collect Personal Information about you from publicly available sources, such as open government databases, real property recorder records, assessor records, and social media platforms (as explained above) and others.</li>
                        <li> User-generated content information: When you communicate with us, either by email, phone, or other means of communication, we also may collect the content of these communications, including but not limited to recordings of phone calls where permitted by law.</li>
</ul>

                    b. Non-Personal Information

                    <ul>
                        <li> Usage Data: Information about how you interact with our Site, such as your IP address, browser type, pages viewed, time spent on pages, and links clicked.</li>
                        <li> Cookies: We may use cookies and similar technologies to enhance your experience, track user preferences, and gather data for analytics.</li>
                    </ul>
                </p>


                <p><strong>2. How We Use Your Information</strong></p>


                <p>
                    We use the collected information to:

                    <ul>
                        <li> Process Loan Applications: Evaluate eligibility, creditworthiness, and manage loan agreements.</li>
                        <li> Provide Services: Facilitate transactions, process payments, and manage investments.</li>
                        <li> Improve User Experience: Personalize your experience, improve our website functionality, and optimize our services.</li>
                        <li> Communicate with You: Respond to inquiries, provide customer service, and send updates related to your account, products, or services.</li>
                        <li> Legal Compliance: Comply with legal and regulatory requirements, including anti-money laundering and know-your-customer regulations.</li>
                        <li> Marketing and Promotions: With your consent, send you newsletters, updates, or offers that may be of interest to you.</li>
                    </ul>
                </p>


                <p><strong>3. How We Share Your Information</strong></p>


                <p>
                    We do not sell, rent, or trade your personal information to third parties. However, we may share your data in the following situations:

<ul>
    
                        <li> Service Providers: We may share information with third-party vendors, consultants, and other service providers who need access to your data to perform work on our behalf, such as loan processing, data analysis, or customer support.</li>
                        <li> Legal Obligations: We may disclose information when required by law, such as to comply with a subpoena, legal process, or government requests.</li>
                        <li> Business Transfers: In the event of a merger, acquisition, or sale of assets, your information may be transferred as part of the transaction.</li>
                        <li> With Your Consent: We may share your information with third parties if you give us explicit consent.</li>
</ul>

                </p>

                <p><strong>4. Data Security</strong></p>


                <p>
                    We take data security seriously and implement various technical, administrative, and physical measures to protect your personal and financial information. However, no method of transmission over the internet or method of electronic storage is 100% secure, and we cannot guarantee the absolute security of your information.

                    In the event of a data breach, the company will promptly activate its Data Breach Response Plan to minimize harm and comply with legal obligations. Once the investigation confirms the breach, One Life will notify all affected consumers in a timely and transparent manner, with clear details about the nature of the breach, the types of compromised data, potential risks, and recommended actions for consumers, such as changing passwords or

                    monitoring accounts. Communication will be sent via email, postal mail, or other direct methods, and additional updates may be provided on the company’s website or through public announcements if the breach affects a large audience.

                </p>

                <p>
                    <p><strong>5. Data Retention</strong></p>


                    We retain your personal information for as long as necessary to fulfill the purposes outlined in this Privacy Policy or as required by law. When your data is no longer needed, we will securely dispose of it.
                </p>


                <p>
                    <p><strong>6. Your Rights</strong></p>


                    You have the following rights regarding your personal information:


                    <ul>
                        <li> Access and Correction: You may request access to your personal data and request corrections if the information is inaccurate or incomplete.</li>
                        <li> Deletion: You may request the deletion of your personal information under certain circumstances.</li>
                        <li> Opt-Out of Marketing: You may opt out of receiving marketing communications at any time by following the unsubscribe instructions included in the email or contacting us directly.</li>
                        <li> Data Portability: You may request that we provide you with a copy of your personal data in a structured, commonly used, and machine-readable format.</li>
                    </ul>


                    To exercise these rights, please contact us using the details provided in Section 9.
                </p>





                <p>
                    <p><strong>7. Third-Party Links</strong></p>


                    Our Site may contain links to third-party websites or services that are not operated or controlled by One Life Funding. We are not responsible for the privacy practices or the content of these external sites. We encourage you to review their privacy policies before engaging with them.

                </p>

                <p>
                    <p><strong>8. Cookies Policy</strong></p>


                    We use cookies to improve your experience on our Site. Cookies are small data files that are stored on your browser or device. You can control the use of cookies by adjusting your browser settings, but please note that disabling cookies may affect your ability to use certain features of the Site.
                </p>


                <p>
                    <p><strong>9. Contact Us</strong></p>


                    If you have any questions or concerns about this Privacy Policy or your personal information, please contact us at:

                    <br/>
                    <br/>

                    One Life Funding
<br/>
                    81 Lincoln St.
                    <br/>

                    Hampton, VA 23669-3521
                </p>


                <p>
                    <p><strong>10. Children</strong></p>

                    One Life Equity Fund’s Platform and Services are intended for use by general audiences and are not targeted directly at children under 18.


                    Children under the age of 18 are not permitted to use the One Life Equity Fund’s Platform or Services, and we do not seek or knowingly collect any Personal Information about

                    children under 18 years of age. If we become aware that we have unknowingly collected information about a child under 18 years of age, we will make commercially reasonable efforts to delete such information from our database. If you are the parent or guardian of a child under 18 years of age who has provided us with their Personal Information, you may contact us at privacy@Onelifefunding.com to request that it be deleted.

                </p>

                <p>
                    <p><strong>11. Changes to This Privacy Policy</strong></p>


                    We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated "Last Updated" date. We encourage you to review this Privacy Policy periodically to stay informed about how we protect your information.
                </p>


                <p>
                    <p><strong>12. Supplemental notice to residents of California, Colorado, Connecticut, Montana, Oregon, Texas, Utah and Virginia</strong></p>


                    California

<br/>



                    This section contains disclosures required by the California Consumer Privacy Act (“CCPA”) and applies only to “Personal Information” that is subject to that law. However, if you are an eligible resident of California, the CCPA may apply to our One Life Equity Fund Services as they relate to business products featured on our site (for example, small business loans). Please review our California Privacy Policy for our California privacy disclosures and information on how to exercise your CCPA rights.

                    <br/>
                    <br/>

                    Colorado, Connecticut, Montana, Oregon, Texas, Utah and Virginia

                    <br/>

                    Eligible residents of Colorado, Connecticut, Montana, Oregon, Texas, Utah and Virginia also have rights with respect to the Personal Information that One Life Equity Fund collects about them. This section supplements this Privacy Policy and applies solely to eligible residents of Colorado, Connecticut, Montana, Oregon, Texas, Utah and Virginia.

                    Any terms not defined in this section have the same meaning as defined under applicable Colorado, Connecticut, Montana, Oregon, Texas, Utah and Virginia privacy law, including the Colorado Privacy Act, Connecticut Data Privacy Act, Montana Consumer Data Privacy Act, Oregon Consumer Privacy Act, Texas Data Privacy and Security Act, Utah Consumer Privacy Act and Virginia Consumer Data Protection Act. Subject to certain exceptions, if you are an eligible resident of one of these states, you have certain privacy rights which may include, depending on your state of residency:

                    <br/>
                    <br/>

                    <strong>Right to Know/Access.</strong> You have the right to confirm whether One Life Equity Fund processes your Personal Information and access such Personal Information. You also have the right to obtain your Personal Information in a portable, and to the extent reasonable feasible, readily usable format that you can transmit without hindrance. In addition, eligible Oregon residents have the right to receive a list of specific third parties to which One Life Equity Fund has disclosed any Personal Information.
                    <br/>
                    <br/>

                    <strong>Right to Delete.</strong> You have the right to request that One Life Equity Fund delete the Personal Information you have provided to us or that One Life Equity Fund has otherwise obtained about you.
                    <br/>
                    <br/>

                    <strong>Right to Correct.</strong> You have the right to request that One Life Equity Fund correct inaccuracies in your Personal Information, taking into account the nature of the Personal Information and the purposes of the processing of your Personal Information.
                    <br/>
                    <br/>

                    <strong>Right to Opt Out.</strong> You have the right to opt out of the processing of your Personal Information for the purposes of (i) targeted advertising, (ii) the sale of your Personal Information and (iii) profiling in furtherance of decisions, including, for eligible residents of Connecticut and Montana, solely automated decisions, that produce legal or similarly significant effects.
                    <br/>
                    <br/>

                    <strong>Right to Appeal.</strong> You have the right to appeal One Life Equity Fund’s decision with regard to your request to exercise any rights described herein.

                    To exercise your consumer rights to request, know or delete, please submit your request by: Sending us an email at privacy@Onelifefunding.com with the subject line "[State] Consumer Request" and the relevant right identified in the body of the email.

                    <br/>
                    <br/>

                    Additional Disclosures for Colorado Residents: We may sell or use your Personal Information as described in the section “How We Use Your Information” of this Privacy Policy for targeted advertising purposes.
                    <br/>
                    <br/>


                    Supplemental notice to residents of Nevada
                    <br/>
                    <br/>

                    Nevada law gives Nevada consumers the right to request that a company not sell their Personal Information for monetary consideration to certain other parties.  This right applies even if their Personal Information is not currently being sold.  If you are a Nevada consumer and wish to exercise this right, please send an email with the subject line “Nevada Resident Do Not Sell Request” to privacy@Onelifefunding.com.

                </p>



                <p>By using our Site and services, you acknowledge that you have read and understood this Privacy Policy and agree to its terms.</p>

            </div>       </>
    );

}